import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Check, Zap, Lock } from "lucide-react";
import { getRoadmap } from "@/lib/api";

const STATUS_META = {
  completed: { label: "Completed", color: "#39FF14", Icon: Check },
  active: { label: "In Progress", color: "#00F0FF", Icon: Zap },
  upcoming: { label: "Upcoming", color: "#A0AEC0", Icon: Lock },
};

export default function Roadmap() {
  const [phases, setPhases] = useState([]);

  useEffect(() => {
    getRoadmap().then((d) => setPhases(d.phases || [])).catch(() => {});
  }, []);

  return (
    <section id="roadmap" className="relative py-24 sm:py-32 bg-[#070708]" data-testid="roadmap-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF3B30]">// trajectory</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black mt-2">Roadmap</h2>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-3 sm:left-5 top-0 bottom-0 w-px bg-gradient-to-b from-[#39FF14] via-[#00F0FF] to-transparent" />

          <div className="space-y-10">
            {phases.map((p, i) => {
              const meta = STATUS_META[p.status] || STATUS_META.upcoming;
              return (
                <motion.div
                  key={p.phase}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="relative pl-12 sm:pl-16"
                  data-testid={`roadmap-phase-${i}`}
                >
                  <div
                    className="absolute left-0 top-1 w-7 h-7 sm:w-10 sm:h-10 grid place-items-center clip-hex"
                    style={{ background: `${meta.color}22`, border: `1px solid ${meta.color}` }}
                  >
                    <meta.Icon className="w-4 h-4" style={{ color: meta.color }} />
                  </div>
                  <div className="glass p-6 sm:p-7">
                    <div className="flex flex-wrap items-center gap-3 mb-2">
                      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">{p.phase}</span>
                      <span
                        className="font-mono text-[10px] uppercase tracking-[0.25em] px-2 py-0.5"
                        style={{ color: meta.color, border: `1px solid ${meta.color}55` }}
                      >
                        {meta.label}
                      </span>
                    </div>
                    <h3 className="font-display text-xl sm:text-2xl font-bold mb-4">{p.title}</h3>
                    <ul className="space-y-2">
                      {p.items.map((it) => (
                        <li key={it} className="flex items-start gap-3 text-white/70 font-mono text-sm">
                          <span className="mt-1.5 w-1.5 h-1.5" style={{ background: meta.color }} />
                          <span>{it}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
